import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CommunicationType } from 'common/store/genesys-cloud/conversations/common/models/communication-type.enum';
import { WrapUpCode } from 'common/store/genesys-cloud/conversations/common/models/wrap-up-code.model';
import {
  loadWrapUpsForEmailConversation,
  saveWrapUpForEmailConversation,
  skipWrapUpForEmailConversation
} from 'common/store/genesys-cloud/conversations/emails/actions/email-conversation.actions';
import {
  selectIsConversationOpen,
  selectWrapupPrompt,
  selectWrapUpsByConversationId
} from 'common/store/genesys-cloud/conversations/emails/selectors/email-conversation.selectors';

@Component({
  selector: 'app-genesys-email-wrapup-panel',
  templateUrl: './genesys-email-wrapup-panel.component.html',
  styleUrls: ['./genesys-email-wrapup-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysEmailWrapupPanelComponent implements OnInit {
  @Input() conversationId: string;
  @Input() selectedWrapUp: WrapUpCode;

  @Output() selectWrapUpCode = new EventEmitter();
  @Output() toggleWrapUpPanel = new EventEmitter();

  wrapUpCodes$: Observable<WrapUpCode[]>;
  isWrapUpRequired$: Observable<boolean>;
  isConversationOpen$: Observable<boolean>;
  readonly communicationTypes = CommunicationType;

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(loadWrapUpsForEmailConversation({ conversationId: this.conversationId }));
    this.wrapUpCodes$ = this.store.select(selectWrapUpsByConversationId(this.conversationId));

    this.isWrapUpRequired$ = this.store.select(selectWrapupPrompt(this.conversationId));

    this.isConversationOpen$ = this.store.select(selectIsConversationOpen(this.conversationId));
  }

  selectWrapUp(wrapUpCode: WrapUpCode): void {
    this.selectWrapUpCode.emit(wrapUpCode);
  }

  saveWrapUp(wrapUpCode: WrapUpCode): void {
    this.store.dispatch(
      saveWrapUpForEmailConversation({ conversationId: this.conversationId, wrapUpCode: wrapUpCode.id })
    );
  }

  skipWrapUp(): void {
    this.store.dispatch(skipWrapUpForEmailConversation({ conversationId: this.conversationId }));
  }

  toggleWrapUp(): void {
    this.toggleWrapUpPanel.emit();
  }
}
